const DEFAULTS = {
	feature: null,
};

const BASE_API_URL = 'wp-json';
interface Options {
	feature?: string;
}

class API {
	private entryPoint: string;
	constructor( options: Options ) {
		let feature = options.feature || DEFAULTS.feature;
		this.entryPoint = `${ BASE_API_URL }/${ feature }`;
	}

	call = ( method, value ) => {
		let slug = `${ this.entryPoint }/${ method }`;
		let result;
		if ( typeof value === 'object' ) {
			result = this.filter( slug, value );
		}
		if ( ! result ) {
			result = "Can't load Api";
			// eslint-disable-next-line no-console
			console.error( result );
		}
		return result;
	};

	getApiUrl = ( slug: string ) => {
		// eslint-disable-next-line no-undef
		let apiObjectDecoded =   window.apiObjectBE
		return `${ apiObjectDecoded.rootapiurl }${ slug }?_wpnonce=${ apiObjectDecoded.nonce }`;
	};
	getApi = ( slug: string ) => {
		let url = this.getApiUrl( slug );
		return fetch( url, {
			method: 'GET',
			cache: 'no-cache',
			mode: 'cors',
			headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/json',
			},
		} )
			.then( response => response.json() )
			.then( data => {
				return data;
			} );
	};
	filter = ( slug: string, value: object ) => {
		// eslint-disable-next-line no-undef
		let url = this.getApiUrl( slug );
		return fetch( url, {
			method: 'POST',
			cache: 'no-cache',
			mode: 'cors',
			headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/json',
			},
			body: JSON.stringify( {
				value,
				// eslint-disable-next-line no-undef
				wp_rest: window.apiObject?.nonce,
			} ),
		} )
			.then( response => response.json() )
			.then( data => {
				return data;
			} );
	};
}

export default API;
